export const PARTNER_PAGE = 'partnerPage';
export const LAST_UPDATE_KEY = 'lastUpdate';
export const CACHE_THRESHOLD = 1000 * 60 * 30; // 30 Minutes
